import tripStates from "./constants/tripStates";

export const sortPointsByPosition = (tripPoints) => [
    ...tripPoints.sort((a, b) => (a.pointType === "pickup" ? -1 : a.position - b.position)),
];

export const getCurrentPointId = (tripPoints, currentTripPointId, tripStatus) => {
    const currentPointIndex = tripPoints.findIndex((trip) => +trip.id === currentTripPointId);
    if (currentPointIndex === -1) {
        return null;
    }
    const currentPoint =
        tripPoints[tripStatus === tripStates.MOVING ? currentPointIndex - 1 : currentTripPointId];

    return (currentPoint && +currentPoint.id) || currentTripPointId;
};
